import script from "./VIsAiListSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./VIsAiListSelect.vue?vue&type=script&lang=ts&setup=true"

import "./VIsAiListSelect.vue?vue&type=style&index=0&id=fe9d3152&lang=sass"

const __exports__ = script;

export default __exports__